import { render, staticRenderFns } from "./MoveProductCell.vue?vue&type=template&id=85a5aeba&scoped=true"
import script from "./MoveProductCell.vue?vue&type=script&lang=js"
export * from "./MoveProductCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a5aeba",
  null
  
)

export default component.exports